import { KindeUser } from "../models/organisation";
import axiosConfig from "./axiosConfig";

const deleteOrganisationUser = async (
  authToken: string,
  orgId: string,
  user: KindeUser
): Promise<void> => {
  const { data } = await axiosConfig.delete(`/organisation/${orgId}/user`, {
    data: user,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default deleteOrganisationUser;
